import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { OfferSection } from '../components/OfferSection';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <>
      <MetaPixel data-id="element-213" />
      <main className="min-h-screen bg-navy-900 font-body text-slate-200 overflow-x-hidden" data-id="element-214">
        <HeroSection data-id="element-215" />
        <ProblemSection data-id="element-216" />
        <SolutionSection data-id="element-217" />
        <AudienceSection data-id="element-218" />
        <SocialProofSection data-id="element-219" />
        <OfferSection data-id="element-220" />
      </main>
    </>;
}